module.exports = __webpack_public_path__ + "images/icons/icon-info-a582ce1c.svg";